import React, { useState } from "react";
import PropTypes from "prop-types";

import DeleteForever from "@mui/icons-material/DeleteForever";
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import SoftButton from "../../../components/SoftButton";
import { useDeleteLink } from "../hooks";

const DeleteLink = ({ brandId, payByLinkId }) => {
  const { mutate, isLoading } = useDeleteLink(brandId);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);

  const handleDelete = async () => {
    mutate(
      { brandId, payByLinkId },
      {
        onSuccess: () => {
          handleClose();
        },
      }
    );
  };

  return (
    <>
      <Tooltip title="Delete">
        <IconButton onClick={handleOpen} disabled={isLoading}>
          <DeleteForever />
        </IconButton>
      </Tooltip>
      <Dialog open={isOpen} onClose={handleClose} maxWidth="xs">
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <SoftBox p={3} minWidth="300px">
            <SoftTypography variant="h6" textAlign="center">
              Are you sure?
            </SoftTypography>
          </SoftBox>
          <SoftBox display="flex" gap={2} justifyContent="center">
            <SoftButton type="submit" onClick={handleClose}>
              Cancel
            </SoftButton>
            <SoftButton
              variant="gradient"
              color="error"
              onClick={handleDelete}
              isLoading={isLoading}
              disabled={isLoading}
            >
              Delete
            </SoftButton>
          </SoftBox>
        </DialogContent>
      </Dialog>
    </>
  );
};

DeleteLink.propTypes = {
  brandId: PropTypes.string,
  payByLinkId: PropTypes.string,
};

export default DeleteLink;
